import { Injectable } from '@angular/core';
import { CHttp } from '../../core/services/chttp.service';
import { config } from '../../app.config';

@Injectable()
export class SubscriptionPlansService {
  constructor(private http: CHttp) { }

  public getSubscriptionPlansData() {
    return new Promise((resolve, reject) => {
      this.getAllSubscriptionPlans().subscribe(resp => {
        let jsonResult = resp.json();
        let locations: any[] = [];
        for (let item of jsonResult) {
          if (isEmptyString(item.name)) {
            continue;
          }

          let name: string[] = [];
          let ti = item;
          while (ti) {
            name.unshift(ti.name);
            ti = getParentSubscriptionPlans(ti.parentSubscriptionPlansId);
          }
          locations.push({
            value: name.join(', '),
            id: item.id
          });
        }

        locations.sort((a, b) => a.value.localeCompare(b.value));
        resolve(locations);

        function getParentSubscriptionPlans(id: string) {
          for (let item of jsonResult) {
            if (isEmptyString(item.name)) {
              continue;
            }

            if (id === item.id) {
              return item;
            }
          }

          return null;
        }

        function isEmptyString(str) {
          return 'string' !== typeof str || '' === str.trim();
        }
      });
    });
  }

  public getAllSubscriptionPlans(showArchived?: boolean) {
    return this.http.get(config.api_url + 'plans' + (showArchived ? '?showArchived=true' : ''));
  }

  public getAllRafDefaultPlans() {
    return this.http.get(config.api_url + 'plans/raf-default');
  }

  public addSubscriptionPlans(data: any) {
    return this.http.post(config.api_url + 'plans', data);
  }

  public editSubscriptionPlans(data: any) {
    return this.http.put(config.api_url + 'plans/' + data.id, data);
  }

  public getAllIntervalTypes() {
    return this.http.get(config.api_url + 'plans/interval-types');
  }

  public getAllTypes() {
    return this.http.get(config.api_url + 'plans/types');
  }

  public getProductPlan(id: string) {
    return this.http.get(config.api_url + 'plans/' + id);
  }

  public getMembershipCode(id: string) {
    return this.http.get(config.api_url + 'promo-codes/' + id);
  }

  public getAppPlansShort() {
    return this.http.get(config.api_url + 'plans/app-short');
  }

  public getMagazinePlansShort() {
    return this.http.get(config.api_url + 'plans/magazine-short');
  }

  public getReferralCodePlansShort() {
    return this.http.get(config.api_url + 'plans/promo-codes-short');
  }

  public archivePlan(id: string) {
    return this.http.put(config.api_url + 'plans/' + id + '/archive');
  }

  public unarchivePlan(id: string) {
    return this.http.put(config.api_url + 'plans/' + id + '/unarchive');
  }

  public deletePlan(id: string) {
    return this.http.delete(config.api_url + 'plans/' + id);
  }

  public getLocationParentTree(id: string) {
    return new Promise((resolve, reject) => {
      let self = this;
      let data = [];
      self.getProductPlan(id).subscribe(handle);

      function handle(resp) {
        if (200 === resp.status) {
          let respData = resp.json();
          data.unshift({
            name: respData.name,
            id: respData.id,
            parentId: respData.parentLocationId,
          });
          if (!respData.parentLocationId) {
            resolve(data);
            return;
          }

          self.getProductPlan(respData.parentLocationId).subscribe(handle);
        } else {
          resolve(data);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/subscription-plans/services/subscription-plans.service.ts